import React, {useEffect, useState} from 'react';
import Breadcrumbs from '../Components/Breadcrumbs';
import Table from '../Components/Tables';
import {ConfirmationProvider, useConfirmation} from '../Components/ConfirmationContext';
import {AlertProvider, useAlert} from '../Components/AlertContext';
import {formatDateUTC} from '../utils/formatDateUTC';

import {useNavigate, useParams} from "react-router-dom";
import {ConnectionApiProvider, useConnectionApi} from "../Services/ConnectionApiProvider";
import Button from "../Components/Buttons";

function Connections({canEdit}) {
  const {getConnection, deleteConnection} = useConnectionApi();
  const {organizationId} = useParams();
  const { showAlert } = useAlert();
  const { showConfirmation } = useConfirmation();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [connections, setConnections] = useState([]);
  const [totalConnections, setTotalConnections] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const navigate = useNavigate();


  const columns = [
    {name: 'ID', selector: (row) => row.id, sortable: true},
    {name: 'type', selector: (row) => row.type, sortable: true},
    {name: 'name', selector: (row) => row.name, sortable: true},
    {name: 'Active', selector: (row) => row.is_active ? 'Active' : 'Inactive', sortable: true},
    {name: 'Created', selector: (row) => formatDateUTC(row.created_at), sortable: true},
    {name: 'Updated', selector: (row) => formatDateUTC(row.updated_at), sortable: true},
  ];

  const fetchConnections = async (skip, limit) => {
    if (limit !== itemsPerPage) {
      setItemsPerPage(limit);
    }
    try {

      setLoading(true);
      const response = await getConnection(skip, limit);
      setConnections(response.items);
      setTotalConnections(response.totalCount);
      setItemsPerPage(limit);
    } catch (error) {
      console.error("Error fetching connections:", error);
      setError("Failed to load connections");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchConnections(0, itemsPerPage);
  }, []);

  const handleRowClicked = (row) => {
    navigate(`/organizations/${organizationId}/connections/${row.id}`);
  };

    const handleDelete = async (selectedId) => {
    if (!selectedId) return;
    showConfirmation(
        `Are you sure you want to delete the selected Connection?`,
        async () => {
            try {
              setLoading(true);
              await deleteConnection(selectedId);
              fetchConnections(0, itemsPerPage);
              showAlert('success', 'Connection was successfully deleted!');
            } catch (error) {
              showAlert('fail', 'Failed to delete the connection!');
            }
        }
    );
  };


  return (
    <div className="container">
      <Breadcrumbs/>
      <div className="row d-flex gap">
        <div className="radius-yes p-2 bg-yes col-12">
          {error ? (
            <div>Error: {error}</div>
          ) : (
            <>
              <Table
                title="Connections"
                columns={columns}
                data={connections}
                selectableRowsHighlight
                selectableRows
                progressPending={loading}
                paginationPerPage={itemsPerPage}
                onRowClicked={handleRowClicked}
                onDelete={handleDelete}
                paginationTotalRows={totalConnections}
                sortIcon={<i className="fa-solid fa-chevron-down"></i>}
                onChangePage={fetchConnections}
              />
              {canEdit &&(
                <Button
                  background="color2"
                  size="large"
                  onClick={() => navigate(`/organizations/${organizationId}/connections/new-connection`)}
                >
                  Create New connection
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function ConnectionsWrapper({canEdit}) {
  return (
    <AlertProvider>
      <ConfirmationProvider>
        <ConnectionApiProvider>
          <Connections canEdit={canEdit}/>
        </ConnectionApiProvider>
      </ConfirmationProvider>
    </AlertProvider>
  );
}

export default ConnectionsWrapper;